import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Components
import DataTable from "react-data-table-component";
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/SupplierConstants";
import { getPostDispatchDocList } from "../../../../redux/feature/customer_app/customerV1Slice";
import { SearchField } from "../../../../Components/formElements/SearchField";
import { formatDateTime } from "../../../../common/Validations";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";

//Serivce
import ItemService from "../../../../services/customer_appCommonService";
import { InputField } from "../../../../Components/formElements/InputField";
import toast from "react-hot-toast";
import InvoiceConfirmationModal from "./InvoiceConfirmationModal";

const DispatchConfirmationList = () => {
  const dispatch = useDispatch();

  localStorage.setItem("menu", "Order");
  localStorage.setItem("submenu", "Dispatch Confirmation");

  let userData = useSelector((state) => state?.user?.data); // User Details from Store
  let postDispatchDocData = useSelector(
    (state) => state?.customerV1?.postDispatchDoc
  ); // User Details from Store
  let postDispatchDocTable = useSelector(
    (state) => state?.customerV1?.postDispatchDoc.pagination
  ); // User Details from Store

  const [isCardVisible1, setCardVisible1] = useState(true);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const [data, setData] = useState();
  // console.log(">>data",data)
  const [getModalEditInvoice, setModalEditInvoice] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const [viewInvoiceData, setViewInvoiceData] = useState(null);

  const showEditInvoice = (invoiceNumber, dispatchDocNr) => {
    let obj = {
      dispatchInvoiceNumber: invoiceNumber,
      dispatchDocNr,
    };
    setModalEditInvoice(true);
    setInvoiceData(obj);
  };
  const hideModal = () => {
    setModalEditInvoice(false);
  };

  const viewInvoice = (data) => {
    let obj = {
      dispatchInvoiceNumber: data.invoiceNumber,
      dispatchDocNr:data.dispatchDocNr,
    };
    setModalEditInvoice(true);
    setViewInvoiceData(data);
    setInvoiceData(obj);
  };
  const userListColInfo = [
    {
      name: "Dispatch Nr",
      selector: (row) => row.dispatchDocNr,
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.dispatchDocNr}
          </span>
        </>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Date/Time ",
      selector: (row) => row.createdDate,
      cell: (row) => <>{formatDateTime(row.createdDate)}</>,
      sortable: true,
      width: "120px",
    },
    {
      name: "Customer",
      selector: (row) => row.customerCode,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.customerName} </p>
          <p className="m-0 p-0 ">{row.sapDocumentNumber} </p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Status",
      // selector: (row) => row.orderStatus,
      cell: (row) => (
        <>
          <TableStatusField status={row.dispatchStatus} />
        </>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Invoice Nr",
      selector: (row) => row.invoiceNumber,
      cell: (row) => (
        <>
          <InputField
            className="inputBox text-primary"
            id="invoiceNumber"
            name="invoiceNumber"
            type="text"
            value={row.invoiceNumber}
            disabled={true}
          />
          {/* <span>{row.invoiceNumber}</span> */}
        </>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Invoice Confirm",
      // selector: (row) => row.orderStatus,
      cell: (row) => (
        <>
          {row.dispInvoiceNumber ? (
            <span
              style={{ marginLeft: "30px",fontSize:"30px"}}
              onClick={() => viewInvoice(row)}
              className="iconTableNew"
            >
              <i className="bi bi-receipt-cutoff"></i>
            </span>
          ) : (
            <button
              className="btnTable"
              onClick={() =>
                showEditInvoice(row.invoiceNumber, row.dispatchDocNr)
              }
            >
              Invoice
            </button>
          )}
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "INV btn",
      selector: (row) => row.disptachQty,
      cell: (row) => (
        <>
       <button
              className="btnTable"
              onClick={() =>
                showEditInvoice(row.invoiceNumber, row.dispatchDocNr)
              }
            >
              Invoice
            </button>        </>
      ),
      width: "130px",
    },
    {
      name: "INV Qty(MT)",
      selector: (row) => row.disptachQty,
      cell: (row) => (
        <>
          <span className="text-primary fw-bold">{row.disptachQty}</span>
        </>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "REC Qty(MT)",
      selector: (row) => row.acceptedQtyMT,
      cell: (row) => (
        <>
          <InputField
            className="inputBox text-success"
            id="acceptedQtyMT"
            name="acceptedQtyMT"
            type="text"
            value={row.acceptedQtyMT || ""}
            onChange={(event) => handleInputChange(row.dispatchDocNr, event)}
            // onBlur={(event) => handleInputChangeData(row.documentNumber, event)}
            disabled={row.dispatchStatus === "Confirmed" ? true : false}
          />
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "DIFF Qty(MT)",
      selector: (row) => row.disptachQty,
      cell: (row) => (
        <>
          <InputField
            className="inputBox text-danger"
            id="differenceQtyMT"
            name="differenceQtyMT"
            type="text"
            value={row.differenceQtyMT}
            disabled={true}
          />
        </>
      ),
      sortable: true,
      width: "130px",
    },

    {
      name: "Qty Confirm",
      selector: (row) => row.orderStatus,
      cell: (row) => (
        <>
          {row.dispatchStatus === "InTransit" ? (
            <button
              className="btnTable"
              onClick={() =>
                confirmDispatch(
                  row.dispatchDocNr,
                  Number(row.acceptedQtyMT),
                  row.differenceQtyMT,
                  row.disptachQty
                )
              }
            >
              Qty Confirm
            </button>
          ) : (
            <button className="btnTable" disabled={true}>
              Qty Confirm
            </button>
          )}
        </>
      ),
      sortable: true,
      width: "150px",
    },

    {
      name: "MDP Nr",
      selector: (row) => row.mDPNumber,
      cell: (row) => (
        <>
          <InputField
            className="inputBox"
            id="mDPNumber"
            name="mDPNumber"
            type="text"
            value={row.mDPNumber}
            disabled={true}
          />
          {/* <span>{row.mDPNumber}</span> */}
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Vehical Nr",
      selector: (row) => row.vehicalNumber,
      cell: (row) => (
        <>
          <InputField
            className="inputBox"
            id="vehicalNumber"
            name="vehicalNumber"
            type="text"
            value={row.vehicalNumber}
            disabled={true}
          />
          {/* <span>{row.vehicalNumber}</span> */}
        </>
      ),
      sortable: true,
      width: "160px",
    },

    // {
    //   name: "Order Booking Nr",
    //   selector: (row) => row.orderSchedulingNr,
    //   cell: (row) => (
    //     <>
    //       <span className="m-0 p-0 pt-1 fw-bold">{row.orderSchedulingNr}</span>
    //     </>
    //   ),
    //   sortable: true,
    //   width: "180px",
    // },

    {
      name: "Project Name",
      selector: (row) => row.projectName,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.projectName} </p>
        </div>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Project Address",
      cell: (row) => (
        <>
          <span>{row.getProjectDetails?.projectAddress}</span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Project Location",
    //   selector: (row) => row.location,
    //   cell: (row) => (
    //     <>
    //       <span>{row.location}</span>
    //     </>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Product",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.materialDescription} </p>
          <p className="m-0 p-0 ">{row.materialCode} </p>
        </div>
      ),
    },
    // {
    //   name: "Created By",
    //   selector: (row) => row.createdByName,
    //   cell: (row) => (
    //     <>
    //       <span>{row.createdByName}</span>
    //     </>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
  ];

  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [filteredUserListColInfo, setFilteredUserListColInfo] = useState([]);

  const loadInitialSuuplierData = async () => {
    setData(postDispatchDocData?.data);
  };

  const handleInputChange = (dispatchDocNr, event) => {
    const { name, value } = event.target;

    setData((prevRows) =>
      prevRows.map((row) => {
        if (row.dispatchDocNr === dispatchDocNr) {
          if (Number(value) > Number(row.disptachQty)) {
            toast.error("Entered value cannot exceed INV Qty!", {
              duration: 4000,
              position: "top-right",
            });
            return row; // Return the row unchanged
          }
          return {
            ...row,
            [name]: value,
            differenceQtyMT:
              (Number(row.disptachQty) - Number(value)).toFixed(2) || 0,
          };
        }
        return row;
      })
    );
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "getDispatchDocList",
      module: "DISPATCH",
      page: page,
      per_page: getNewPerPage,
    };

    dispatch(getPostDispatchDocList(obj));
    setData(postDispatchDocData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "getDispatchDocList",
      module: "DISPATCH",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getPostDispatchDocList(obj));
    setData(postDispatchDocData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getDispatchDocList",
      module: "DISPATCH",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getPostDispatchDocList(obj));
  };

  useEffect(() => {
    loadInitialSuuplierData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postDispatchDocData]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "getDispatchDocList",
      module: "DISPATCH",
      page: 1,
      per_page: 10,
    };
    dispatch(getPostDispatchDocList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const confirmDispatch = async (
    dispatchDocNr,
    acceptedQtyMT,
    differenceQtyMT,
    disptachQty
  ) => {
    let obj = {
      dispatchDocNr: dispatchDocNr,
      dispatchStatus: "Confirmed",
      acceptedQtyMT,
      differenceQtyMT,
    };

    if (acceptedQtyMT) {
      if (Number(acceptedQtyMT) > Number(disptachQty)) {
        toast.error("Entered value cannot exceed INV Qty!", {
          duration: 4000,
          position: "top-right",
        });
        return; // Return the row unchanged
      }
    } else {
      toast.error("Accepted Qty not be empty!", {
        duration: 4000,
        position: "top-right",
      });
      return;
    }

    await ItemService.updateDispatchConfirm(obj).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        // setTitle(item?.data);
        handleSearchFuncApi();
      } else {
        // setTitle([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };

  useEffect(() => {
    const userRole = userData?.roles?.[0]?.roleId || null;
    const restrictedColumns = {
      "SALES-MANAGER": ["Qty Confirm", "Invoice Confirm"],
      "SALES-OFFICER": ["Qty Confirm", "Invoice Confirm"],
      "SALES-COORDINATOR": ["Qty Confirm", "Invoice Confirm"],
      "GENERAL-MNGR": ["Qty Confirm", "Invoice Confirm"],
      "SALES-DIRECTOR": ["Qty Confirm", "Invoice Confirm"],
      "DISPATCH-SNR-OFFICER": ["Qty Confirm", "Invoice Confirm"],
      "DISPATCH-OFFICER": ["Qty Confirm", "Invoice Confirm"],
      ADMIN: ["Qty Confirm", "Invoice Confirm"],
      CUSTOMER: [],
    };

    const filteredCol = userListColInfo.filter(
      (col) => !restrictedColumns[userRole]?.includes(col.name)
    );

    setFilteredUserListColInfo(filteredCol);
    // console.log(">> filteredCol", filteredCol);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  const handleSuccessData = async (data) => {
    // console.log(">> data", data);

    await ItemService.updateDispatchInvoice(data).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        handleSearchFuncApi();
      } else {
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle"> Dispatch Confirmation</h2>
                <p className="subText">Dispatch scheduled Confirmation List</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <hr />

            {/* user list */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">OS</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">
                        {" "}
                        Dispatch Confirmation
                      </span>
                      {/*  <span className="subHeaderTitle">
                        View of Supplier List{" "}
                      </span> */}
                    </Col>
                    {/* <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => introVideoShow()}
                      >
                        Order Booking
                      </button>
                    </Col> */}
                    {/* <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col> */}
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={filteredUserListColInfo}
                          data={data}
                          progressPending={postDispatchDocData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={postDispatchDocTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelect}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <InvoiceConfirmationModal
        show={getModalEditInvoice}
        onHide={() => hideModal()}
        invoiceinfo={invoiceData}
        onsuccessdata={handleSuccessData}
        viewInvoiceData={viewInvoiceData}
      />
    </main>
  );
};

export default DispatchConfirmationList;
